


























































import {Component, Vue} from 'vue-property-decorator';
import UiMapCell from '@/components/UiMapCell.vue';
import UiMap from '@/components/UiMap.vue';
import UiLevelStart from '@/components/UiLevelStart.vue';
import Victory from '@/components/Victory.vue';
import Failure from '@/components/Failure.vue';
@Component({components: {Failure, Victory, UiLevelStart, UiMap, UiMapCell}})
export default class App extends Vue {

  private readonly minNumberOfBombs: number = 5;

  private isMapVisible: boolean = false;
  private isLevelStartInfoVisible: boolean = false;
  private isVictoryInfoVisible: boolean = false;
  private isFailureInfoVisible: boolean = false;
  private level: number = 1;
  private numberOfBombs: number = 10;
  private numberOfMarkedCells: number = 0;

  // noinspection JSUnusedGlobalSymbols
  public mounted(): void {
    this.isLevelStartInfoVisible = true;
  }

  // noinspection JSUnusedGlobalSymbols
  public created(): void {
    // @ts-ignore
    this.$vuetify.theme.dark = true;
  }

  private get numberOfBombsProgress(): number {
    const progress = 100 * this.numberOfMarkedCells / this.numberOfBombs;
    return progress <= 100 ? progress : 100;
  }

  private centerMap(): void {
    const wrapper: HTMLElement | null = document.getElementById('wrapper');
    if (wrapper === null) {
      return;
    }
    // @ts-ignore
    const map: HTMLElement = this.$refs.map.$el;
    window.console.log((map.offsetWidth - wrapper.offsetWidth) / 2);
    wrapper.scrollLeft = (map.offsetWidth - wrapper.offsetWidth) / 2;
    wrapper.scrollTop = (map.offsetHeight - wrapper.offsetHeight) / 2;
  }

  private victory(): void {
    this.isVictoryInfoVisible = true;
  }

  private nextLevel(): void {
    this.isMapVisible = false;
    this.level++;
    this.numberOfBombs++;
    this.initLevel();
  }

  private failure(): void {
    this.isFailureInfoVisible = true;
  }

  private previousLevel(): void {
    this.isMapVisible = false;
    this.numberOfBombs--;
    if (this.numberOfBombs < this.minNumberOfBombs) {
      this.numberOfBombs = this.minNumberOfBombs;
    }
    this.initLevel();
  }

  private initLevel(): void {
    this.numberOfMarkedCells = 0;
    this.isLevelStartInfoVisible = true;
  }
}
